import {
  GET_ACTIVITY_MODULES,
  GET_RECENT_ACTIVITIES,
  GET_ACTIVITY_BY_FILTER,
  GET_VOICE_CALLS,
} from 'actions/admin/activities';

// Module names the backend lists for every school but that nothing in this app ever writes an activity for (leftovers of the
// shared HR / CRM module list). They only added dead chips to the Activities quick filter and the module dropdown.
const UNUSED_AUDIT_MODULES = ['CUSTOM_FIELD', 'GENERATE_LEAD', 'PROPOSAL', 'ENQUIRY', 'CUSTOMER', 'INVOICE'];
const usedModules = modules => (modules || []).filter(name => !UNUSED_AUDIT_MODULES.includes(name));

const initialState = {
  modules: [],
  recentActivities: [],
  filterActivities: [],
  voiceCallData: {},
};

export default function activities(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ACTIVITY_MODULES: {
      return { ...state, modules: usedModules(action?.modules) };
    }
    case GET_RECENT_ACTIVITIES: {
      return {
        ...state,
        recentActivities: action.recentActivities,
      };
    }
    case GET_ACTIVITY_BY_FILTER: {
      return {
        ...state,
        filterActivities: action?.filterActivities,
      };
    }
    case GET_VOICE_CALLS: {
      return {
        ...state,
        voiceCallData: action.voiceCalls,
      };
    }
    default:
      return state;
  }
}
